import { useMutation } from '@tanstack/react-query';
import { subscribeToNewsletter } from '../api/newsletter';

export function useNewsletterSubscription() {
    return useMutation({
        mutationFn: (email: string) => subscribeToNewsletter(email),
    });
}

